import {RequestAnfrage} from "../../model/request.anfrage";

/**
 * Class holds all the data of the request inside the stromcheck that the user needs for the frontend.
 */
export class StancheckAnfrage implements RequestAnfrage {
  /**
   * holds the last update we did on the local data
   */
  lastupdate: number;

  /**
   * holds the currecnty active portalId for this request
   */
  portalId: string;

  /**
   * Input of the user
   */
  userInput: any = {};

  /**
   * result of the user's dialog registration
   */
  dialogResult: string = null;

  /**
   * Holds the result from the calculation
   */
  result: any = {};

  /**
   * @inheritdoc
   */
  campaignId: string = null;

  /**
   * @inheritdoc
   */
  lastPath: string = '';

}
